export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  date: string;
  image: string;
}

export const news: NewsItem[] = [
  {
    id: 'n1',
    title: 'Giá vàng thế giới tăng mạnh, vàng trong nước lập đỉnh mới',
    summary: 'Giá vàng thế giới vượt mốc 4.400 USD/ounce nhờ kỳ vọng Fed cắt giảm lãi suất, kéo giá vàng trong nước tăng theo.',
    category: 'Thị trường',
    date: '15/08/2026',
    image: 'https://readdy.ai/api/search-image?query=Shiny%20gold%20bars%20and%20coins%20stacked%20on%20a%20dark%20black%20background%20with%20dramatic%20warm%20golden%20lighting%2C%20luxury%20investment%20concept%2C%20high%20detail%20product%20photography&width=800&height=500&seq=gold-news-1&orientation=landscape',
  },
  {
    id: 'n2',
    title: 'Vàng nhẫn tròn 9999 được nhà đầu tư ưa chuộng',
    summary: 'Nhẫn tròn trơn 9999 ghi nhận thanh khoản tốt nhờ mức chênh lệch mua - bán thấp, phù hợp tích lũy dài hạn.',
    category: 'Phân tích',
    date: '14/08/2026',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20gold%20ring%20on%20dark%20velvet%20surface%20with%20soft%20spotlight%2C%20premium%20jewelry%20photography%2C%20black%20background%2C%20refined%20luxury%20aesthetic&width=800&height=500&seq=gold-news-2&orientation=landscape',
  },
  {
    id: 'n3',
    title: 'Dự báo xu hướng giá vàng tuần tới',
    summary: 'Chuyên gia nhận định giá vàng có thể điều chỉnh nhẹ trước khi tiếp tục đà tăng, nhà đầu tư nên thận trọng.',
    category: 'Dự báo',
    date: '13/08/2026',
    image: 'https://readdy.ai/api/search-image?query=Financial%20chart%20with%20golden%20candlestick%20graph%20on%20dark%20screen%2C%20stock%20market%20analysis%20concept%2C%20black%20and%20gold%20color%20scheme%2C%20clean%20minimal&width=800&height=500&seq=gold-news-3&orientation=landscape',
  },
];

export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  type: 'price' | 'trade' | 'system' | 'promo';
  date: string;
  read: boolean;
}

export const notifications: NotificationItem[] = [
  { id: 'nt1', title: 'Cảnh báo giá vàng', message: 'Giá vàng SJC đã chạm mốc 144.000.000đ/lượng bạn theo dõi.', type: 'price', date: '15/08/2026 14:30', read: false },
  { id: 'nt2', title: 'Giao dịch thành công', message: 'Lệnh mua 2 lượng vàng SJC 9999 đã được khớp thành công.', type: 'trade', date: '14/08/2026 15:40', read: false },
  { id: 'nt3', title: 'Nạp tiền thành công', message: 'Yêu cầu nạp 100.000.000đ đã được xử lý và cộng vào tài khoản.', type: 'system', date: '14/08/2026 10:20', read: true },
  { id: 'nt4', title: 'Ưu đãi phí giao dịch', message: 'Giảm 50% phí giao dịch cho mọi lệnh mua vàng trong tháng 8.', type: 'promo', date: '12/08/2026 08:00', read: true },
];